import React, { useState } from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import ReactTooltip from 'react-tooltip';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import data from './countries.json';

const geoUrl =
  'https://raw.githubusercontent.com/zcreativelabs/react-simple-maps/master/topojson-maps/world-110m.json';

const colorScale = (dg: string) => {
  let color;
  switch (dg) {
    case 'DEVCO':
      color = '#833443';
      break;
    case 'ECHO':
      color = '#f47720';
      break;
    case 'NEAR':
      color = '#f0ba89';
      break;
    case 'DEVCOECHO':
      color = '#fcb715';
      break;
    case 'NEARECHO':
      color = '#034ea1';
      break;
  }
  return color;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    map: {
      width: '100%',
    },
  }),
);

const MapChart = () => {
  const [content, setContent] = useState('');
  const classes = useStyles();
  return (
    <>
      <ComposableMap
        className={classes.map}
        data-tip=""
        projection="geoMercator"
        projectionConfig={{
          rotate: [-6, 0, 0],
          scale: 240,
        }}
      >
        {data.length > 0 && (
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map((geo, i) => {
                const d = data.find((s) => s.ISO3 === geo.properties.ISO_A3);

                return (
                  <Geography
                    key={i}
                    geography={geo}
                    fill={d ? colorScale(d['DG']) : 'white'}
                    stroke={d ? 'white' : 'white'}
                    style={{
                      default: {
                        outline: 'none',
                      },
                      hover: {
                        outline: 'none',
                      },
                      pressed: {
                        outline: 'none',
                      },
                    }}
                    onMouseEnter={() => {
                      if (d) {
                        const { NAME } = geo.properties;
                        setContent(`${NAME}`);
                      }
                    }}
                    onMouseLeave={() => {
                      setContent('');
                    }}
                  />
                );
              })
            }
          </Geographies>
        )}
      </ComposableMap>
      <ReactTooltip backgroundColor="black">{content}</ReactTooltip>
    </>
  );
};

export default MapChart;
